import React from 'react';
import { Card } from '../card/card.jsx';
import Highlight from 'react-highlight';
import { formatMarkdown, copyToClipboard } from '../../utils/markdownUtils';

const ChatMessage = ({ message, index }) => {
  if (message.type === 'user') {
    return (
      <div className="d-flex justify-content-end align-items-end mb-3">
        <div className="rounded-4 px-3 py-2 bg-inverse bg-opacity-10 text-body mw-75">
          {message.text}
        </div>
        <div className="w-30px h-30px my-2px ms-2 fs-20px me-2 rounded-circle text-white bg-inverse bg-opacity-50 d-flex align-items-center justify-content-center">
          U
        </div>
      </div>
    );
  }

  if (message.type === 'ai') {
    return (
      <div className="d-flex justify-content-start align-items-end mb-3">
        <div className="w-30px h-30px my-2px ms-2 fs-16px me-2 rounded-circle bg-theme bg-opacity-15 text-theme d-flex align-items-center justify-content-center">
          {message.streaming ? (
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <i className="fa fa-shekel-sign"></i>
          )}
        </div>
        <div className={`rounded-4 px-3 py-2 bg-inverse bg-opacity-10 text-body mw-75 ${message.streaming ? 'border border-primary border-opacity-25' : ''}`}>
          {message.streaming && (
            <div className="d-flex align-items-center mb-2 text-primary opacity-75">
              <i className="fas fa-stream me-2 fs-12px"></i>
              <span className="fs-11px">Streaming response...</span>
            </div>
          )}
          <div className="typing-animation markdown-content" style={{ animationDuration: ".5s" }}>
            {/* Use Highlight component for code blocks in AI responses */}
            {(message.text || '').split('```').map((part, i) => {
              // Even indices are regular text, odd indices are code blocks
              if (i % 2 === 0) {
                return <div key={i} dangerouslySetInnerHTML={{ __html: formatMarkdown(part) }} />;
              } else {
                // Extract language if specified (e.g., ```javascript)
                const languageMatch = part.match(/^([a-zA-Z0-9+-]+)\n/);
                let language = '';
                let code = part;
                
                if (languageMatch) {
                  language = languageMatch[1];
                  code = part.substring(languageMatch[0].length);
                } else {
                  // Check if first line contains language without newline
                  const firstLineMatch = part.match(/^([a-zA-Z0-9+-]+)(.*)$/s);
                  if (firstLineMatch && firstLineMatch[1].length < 20) {
                    language = firstLineMatch[1];
                    code = firstLineMatch[2].replace(/^\n/, '');
                  }
                }
                
                // Clean up the code by removing leading/trailing whitespace
                code = code.trim();
                
                return (
                  <Card key={i} className="my-2">
                    <div className="card-header d-flex border-0 py-2">
                      <span className="flex-1 text-muted small">
                        {language ? language.toUpperCase() : 'CODE'}
                      </span>
                      <span>
                        <a 
                          href="#/" 
                          className="text-body text-decoration-none small" 
                          onClick={async (e) => {
                            e.preventDefault();
                            const success = await copyToClipboard(code);
                            if (success) {
                              // Could add a toast notification here
                              console.log('Code copied to clipboard');
                            }
                          }}
                        >
                          <i className="far fa-copy me-1"></i>Copy
                        </a>
                      </span>
                    </div>
                    <div className="hljs-container bg-dark bg-opacity-75 m-1px p-3" style={{ borderRadius: '0 0 0.375rem 0.375rem' }}>
                      <Highlight className={language || 'plaintext'}>
                        {code}
                      </Highlight>
                    </div>
                  </Card>
                );
              }
            })}
          </div>
          {/* Display think process if available */}
          {message.thinkProcess && (
            <div className="mt-2 pt-2 border-top border-opacity-25">
              <div className="text-muted fs-11px fst-italic opacity-75">
                <i className="fas fa-quote-left me-1"></i>
                {message.thinkProcess}
                <i className="fas fa-quote-right ms-1"></i>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (message.type === 'typing') {
    return (
      <div className="d-flex justify-content-start align-items-end mb-3 ai-spinner">
        <div className="px-2">
          <div className="spinner-grow spinner-grow-sm"></div>
        </div>
      </div>
    );
  }

  return null;
};

const ChatMessages = ({ messages }) => {
  return (
    <div>
      {messages.map((msg, index) => (
        <ChatMessage key={index} message={msg} index={index} />
      ))}
    </div>
  );
};

export default ChatMessages;